/* Version: 3.5.149 */
'use client';
var FORMAT = {
  9: '[0-9]',
  a: '[A-Za-z]',
  '*': '[A-Za-z0-9]',
  // matches a single character that is an uppercase or lowercase letter from the English alphabet, an accented letter from the Latin-1 Supplement Unicode block, or a hyphen
  q: "['A-Za-z\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7-]",
  // matches a single character that is an uppercase or lowercase letter from the English alphabet or an accented letter from the Latin-1 Supplement Unicode block
  S: '[A-Za-zàèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇ]',
  // matches a single character that is an uppercase or lowercase letter from the English alphabet, an accented letter from the Latin-1 Supplement Unicode block, a hyphen, a period, or any whitespace character (space, tab, newline)
  s: "['A-Za-z\xE0\xE8\xEC\xF2\xF9\xC0\xC8\xCC\xD2\xD9\xE1\xE9\xED\xF3\xFA\xFD\xC1\xC9\xCD\xD3\xDA\xDD\xE2\xEA\xEE\xF4\xFB\xC2\xCA\xCE\xD4\xDB\xE3\xF1\xF5\xC3\xD1\xD5\xE4\xEB\xEF\xF6\xFC\xFF\xC4\xCB\xCF\xD6\xDC\u0178\xE7\xC7\\s-.]"
};

/**
 * When the TextInput has a mask, it renders an InputMask from react-input-mask.
 * This does accept a ref prop (inputRef) but it expects it to be a functional ref
 * and does not work with the newer ref object from useRef.
 * Wrapping the object in a function supports it with and without masks.
 */
function wrapRefObjectAsFunctionalRef(ref) {
  return function (element) {
    if (ref) {
      // eslint-disable-next-line no-param-reassign
      ref.current = element;
    }
  };
}

export { FORMAT, wrapRefObjectAsFunctionalRef };
